t = require('views/internal/teacup-with-helpers')('action')
entityTemplate = require './entity'
memberAvatarTemplate = require './member_avatar'

module.exports = t.renderable (data, context, options) ->
  { entities, saved, dateLastEdited, date, url } = data
  { member, board, organization, canReply, canReplyAll, canDelete, canEdit, canAttachLink } = context
  { useEmbedly, usePreviews, showOptions } = options

  t.div '.phenom-creator', ->

    if member
      t.div '.member.js-show-mem-menu', { idmember: member.id }, ->
        memberAvatarTemplate(member)
    else
      t.span '.icon-lg.icon-member'

  t.div '.phenom-desc', ->

    for entity in entities
      entityTemplate(entity, context, options)

    if useEmbedly
      t.div '.hide.embedly.js-embedly'

    if usePreviews
      t.div '.hide.previews.js-previews'

  t.p '.phenom-meta.quiet', ->
    if saved
      if url
        t.a '.date.js-hide-on-sending.js-highlight-link', { dt: date, href: url }
      else
        t.span '.date.js-hide-on-sending', { dt: date, href: url }
    if dateLastEdited
      t.span '.js-date-title.js-hide-on-sending', { dt: dateLastEdited }, ->
        t.text ' '
        t.format 'edited'
    t.span { class: t.classify('js-spinner': true, hide: saved) }, ->
      t.format 'sending-ellipsis'

    if board
      { boardPLevelAltText, boardPLevelIconClass } = context
      t.text ' - '
      t.format 'on-board-name', { url: board.url, name: board.name, boardPLevelAltText, boardPLevelIconClass }

    if organization
      { orgPLevelAltText, orgPLevelIconClass } = context
      t.text ' - '
      t.format 'on-organization-name', { url: organization.url, name: organization.name, orgPLevelAltText, orgPLevelIconClass }

    if showOptions
      t.span '.js-hide-on-sending', ->
        if canReply
          t.text " - "
          t.a {
            href: '#'
            class:
              if canReplyAll
                'js-reply-to-all-action'
              else
                'js-reply-to-action'
          }, ->
            t.format 'reply'
        if canEdit
          t.text " - "
          t.a '.js-edit-action', { href: '#' }, ->
            t.format 'edit'
        if canAttachLink
          t.text " - "
          t.a '.js-attach-link', { href: '#' }, ->
            t.format 'attach link'
        if canDelete
          t.text " - "
          t.a '.js-confirm-delete-action', { href: '#' }, ->
            t.format 'delete'
        t.span '.edits-warning.quiet', ->
          t.text " - "
          t.format 'you-have-unsaved-edits-on-this-field'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/action.coffee